import { MobileMenu } from 'components/eventView/layout/MobileMenu';
import { motion } from 'framer-motion';
import { AnimTap2, EColors2 } from 'libs/styles/styling';
import { useContext, useEffect } from 'react';
import { scrollSpy } from 'react-scroll';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MobileHeader = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    useEffect(() => {
        scrollSpy.update();
    }, []);

    return (
        <S_MobileHeader className={props.className}>
            <S_Logo
                {...AnimTap2}
                src={ctxEventView.eventData.eventInfo.logoUrl}
                onClick={() => {
                    ctxEventView.setMobileMenuOpen(true);
                }}
            />
            <S_MobileMenu color={EColors2.DARK} />
        </S_MobileHeader>
    );
};

const S_MobileHeader = styled.div`
    background-color: white;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
`;

const S_Logo = styled(motion.img)`
    display: flex;
    cursor: pointer;
    height: 40px;
`;

const S_MobileMenu = styled(MobileMenu)``;
